import salesforce from "@/store/app/salesforce/recovery/object/object";
import jobs from "@/store/app/salesforce/recovery/jobs";
import settings from "@/store/app/salesforce/settings/connectionSettings";


export default {
  namespaced: true,

  actions: {},

  modules: {
    salesforce,
    jobs
  }
}
